import {DetailsFieldsCard} from '@/components/ui/details-atoms/DetailsAtoms'
import {Text} from '@/components/ui/text/Text'
import {useGetPlannedAccessesDetails} from '@/features/planned-accesses/queries/useGetPlannedAccessesDetails'
import {useTranslation} from '@/translations/i18n'
import {Trans} from 'react-i18next'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useMemo} from 'react'
import {calculateTotalAccessInAbsence, calculateTotalPlannedAccesses} from '../../utils'

export const PlannedAccessCounterCard = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {t} = useTranslation()

    const {data: plannedAccesses, isLoading: isLoadingPlannedAccesses} = useGetPlannedAccessesDetails({
        urlParams: {
            projectId: project.id
        }
    })

    const totalAccesses = useMemo(() => {
        if (!plannedAccesses) return 0
        return calculateTotalPlannedAccesses(project.durationDays ?? 0, plannedAccesses)
    }, [plannedAccesses])

    const totalAccessInAbsence = useMemo(() => {
        if (!plannedAccesses) return 0
        return calculateTotalAccessInAbsence(plannedAccesses)
    }, [plannedAccesses])

    return (
        <DetailsFieldsCard size="md" direction="column" gap={2}>
            <Text size="textSm">{t('projects:planned_accesses')}</Text>
            {isLoadingPlannedAccesses ? (
                <Skeleton height={30} width={130} />
            ) : plannedAccesses ? (
                <Text palette="neutral" shade="500" weight="500" size="textXs">
                    <Trans
                        i18nKey="projects:planned_accesses_description"
                        values={{count: totalAccesses, count_absence: totalAccessInAbsence}}
                        components={[
                            <Text palette="neutral" shade="950" weight="500" size="displayXs" render="span" />
                        ]}
                    />
                </Text>
            ) : (
                <Text palette="neutral" shade="500" weight="500" size="textXs">
                    -
                </Text>
            )}
        </DetailsFieldsCard>
    )
}
